import BtnOptions from './BtnOptions';
import SelectPlants from '../../../../components/form/Selects/SelectPlants';

const Report6Options = (props) => {
  const { handleOnSetFieldValue, handleOnSubmit, values } = props;

  return (
    <>
      <div className="row">
        <div className="col-lg-12">
          <SelectPlants
            type="userPlants"
            onHandleChange={(opt) => handleOnSetFieldValue('customPlant', opt)}
            format="m"
            value={values.customPlant}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="row">
            <div className="col-12">
              <BtnOptions
                isDisabled={!values.customPlant}
                handleOnSubmit={() => handleOnSubmit()}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Report6Options;
